import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconHeartDonation: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconHeartDonation"><Path d="M12 5.57193C18.3331 -0.86765 29.1898 11.0916 12 20.75C-5.18982 11.0916 5.66687 -0.867651 12 5.57193Z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round"/><Path d="M12 9.2998V8.2998M12 15.7998V16.4998M9.875 14.1748C10.6369 15.6748 13.875 15.5929 13.875 13.9092C13.875 11.7844 10.0655 12.8055 10.0655 10.6331C10.0655 9.16937 12.4094 8.95912 13.5 9.9413" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/></CentralIconBase>;
});

export default IconHeartDonation;
